import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { SettingsHttpService } from '../../../core/settings';
import { map, catchError, take } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/settings/_services/settings-http.service";
import * as i2 from "@angular/router";
/**
 * Resolves machine by machineId from the route and attaches it to route.data.machine.
 * When navigating from the machine list, the list can pass the machine in state to avoid a redundant API call.
 */
var MachineResolver = /** @class */ (function () {
    function MachineResolver(settingsHttp, router) {
        this.settingsHttp = settingsHttp;
        this.router = router;
    }
    MachineResolver.prototype.resolve = function (route) {
        var _this = this;
        var machineId = route.paramMap.get('machineId');
        if (!machineId) {
            return of(null);
        }
        var nav = this.router.getCurrentNavigation();
        var state = nav && nav.extras && nav.extras.state;
        var stateMachine = state && state['machine'];
        var rec = stateMachine;
        var stateId = rec != null && rec.machine_id != null ? rec.machine_id : (rec != null && rec.m_id != null ? rec.m_id : undefined);
        if (stateMachine && stateId === machineId) {
            var normalized = this.normalizeMachine(stateMachine, machineId);
            return of(normalized);
        }
        return this.settingsHttp.getMachineDet(machineId).pipe(take(1), map(function (data) {
            if (!data)
                return null;
            return _this.normalizeMachine(data, machineId);
        }), catchError(function () { return of(null); }));
    };
    MachineResolver.prototype.normalizeMachine = function (data, machineId) {
        var machineIdVal = data.machine_id != null ? data.machine_id : (data.m_id != null ? data.m_id : machineId);
        return tslib_1.__assign({}, data, { machine_id: machineIdVal, serial_no: data.serial_no, machine_name: data.machine_name });
    };
    MachineResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MachineResolver_Factory() { return new MachineResolver(i0.ɵɵinject(i1.SettingsHttpService), i0.ɵɵinject(i2.Router)); }, token: MachineResolver, providedIn: "root" });
    return MachineResolver;
}());
export { MachineResolver };
